<template>
  <div id="suspension-container" class="container">
    <div
      id="suspension"
      class="flex flex-direction align-center justify-center"
    >
      <!-- 聚能行动 -->
      <!-- <div
        class="open flex flex-direction align-center justify-center cs interaction"
        @click="openInteraction"
      >
        <img
          class="img"
          style="height: auto; width: 0.21rem"
          src="../assets/images/suspension/sidebar-icon-interaction.png"
        />
        <div class="text">聚能行动</div>
      </div> -->
      <div
        v-if="!$store.state.isMobile"
        id="recommendBtn"
        ref="recommendBtn"
        class="open"
        @mouseover="showAcceptDialog"
        @mouseleave="hideAcceptDialog"
      >
        <div class="cs flex flex-direction align-center justify-center">
          <img src="../assets/images/suspension/recommend.png" />
          <div class="text">智能推荐</div>
        </div>
        <Recommend
          @mouseover="enter"
          ref="recommendContainerPc"
          v-show="recommendshowPc && !$store.state.isMobile"
          @setAccept="setAccept"
        ></Recommend>
        <AcceptDialog
          @mouseover="enter"
          ref="acceptContainerPc"
          v-show="showAcceptPc"
          @setAccept="setAccept"
        ></AcceptDialog>
      </div>
      <div
        class="open flex flex-direction align-center justify-center cs"
        v-show="!isOpen"
        @click="didClick_open()"
      >
        <img :src="openImgUrl" />
        <div class="text">点我展开</div>
      </div>
      <div
        class="more flex flex-direction align-center justify-around cs"
        v-show="isOpen"
      >
        <div
          class="more_box flex flex-direction align-center justify-center cs"
          @click="changeOpen()"
        >
          <img class="img" :src="closeImgUrl" />
          <div class="text">点我收起</div>
        </div>
        <div
          class="more_box flex flex-direction align-center justify-center cs"
          @click="link(hb, 'hb')"
        >
          <img class="img2" :src="hbImgUrl" />
          <div class="text">成为伙伴</div>
        </div>
        <div
          class="more_box flex flex-direction align-center justify-center cs"
          @click="
            popupShow = true;
            link('', 'zx');
          "
        >
          <img class="img" :src="zxImgUrl" />
          <div class="text">项目咨询</div>
        </div>
        <!--        <div-->
        <!--          class="more_box flex flex-direction align-center justify-center cs"-->
        <!--          @click="link(sy, 'sy')"-->
        <!--        >-->
        <!--          <img class="img" :src="syImgUrl" />-->
        <!--          <div class="text">我要上云</div>-->
        <!--        </div>-->
        <div
          class="more_box flex flex-direction align-center justify-center cs"
          @click="link(st, 'st')"
        >
          <img class="img" :src="stImgUrl" />
          <div class="text yahei">昇腾社区</div>
        </div>
        <div
          class="more_box flex flex-direction align-center justify-center cs"
          @click="link(kp, 'kp')"
        >
          <img class="img" :src="kpImgUrl" />
          <div class="text">鲲鹏社区</div>
        </div>
        <img class="topArror cs" :src="topArror" @click="isOpen = false" />
      </div>

      <div
        class="minipro flex flex-direction align-center justify-center cs"
        @click="didClick_xcx"
      >
        <img
          :src="xcxImgUrl"
          @mouseenter="qrCodeShow = true"
          @mouseout="qrCodeShow = false"
          @click.stop="didClick_xcx"
        />
        <div class="text">小程序</div>
        <div
          class="qrCode"
          v-show="qrCodeShow"
          @mouseenter="qrCodeShow = true"
          @click="qrCodeShow = false"
        >
          <img class="qrImg" src="@/assets/images/suspension/xcx.jpg" />
          <div class="text">查看小程序</div>
        </div>
      </div>
      <!-- <div
        class="assistant flex flex-direction align-center justify-start cs"
        @click="
          uniknowShow = true;
          didClick_xzs();
        "
      >
        <img :src="assistantImgUrl" />
        <span>参会小助手</span>
      </div> -->
      <div
        v-show="uniknowShow"
        class="know-popup"
        :style="{ width: knowPopupWidth }"
      >
        <div class="ai-know-title flex align-center justify-end">
          <div
            class="ai-title-allscreen flex align-center justify-center"
            @click="popup_allscreen"
          >
            <img :src="allscreenImg" class="know-icon-allscreen" />
            <p class="ai-title-allscreen_hover">展开全屏</p>
          </div>
          <div
            class="ai-title-close flex align-center justify-center"
            @click="uniknowShow = false"
          >
            <img :src="popCloseImg" class="know-icon-close" />
          </div>
        </div>
        <iframe
          id="iframeContain"
          name="iframeContain"
          frameborder="0"
          allowfullscreen="allowfullscreen"
          scrolling="no"
          allow="camera *;microphone *;"
          border="0"
          src="https://app.huawei.com/events/ecomknow/"
        >
          您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
        </iframe>
      </div>
    </div>
    <div
      id="suspension-wap"
      ref="suspensionWap"
      :style="{
        top: scrollTop > 0 && isOpen ? 100 - scrollTop + 'px' : '',
      }"
      :class="scrollTop > 0 && isOpen ? 'scroll-open' : ''"
      class="flex flex-direction align-center justify-center"
    >
      <!-- 聚能行动 -->
      <!-- <div class="more flex flex-direction align-center justify-around">
        <div
          class="more_box flex flex-direction align-center justify-center cs"
          @click="openInteractionWap"
        >
          <img
            class="img"
            style="height: auto; width: 0.21rem"
            src="../assets/images/suspension/sidebar-icon-interaction.png"
          />
          <div class="text">聚能行动</div>
        </div>
      </div> -->

      <div class="more flex flex-direction align-center justify-around">
        <div
          class="more_box flex flex-direction align-center justify-center cs"
          @click="
            popupShow = true;
            link('', 'zx');
          "
        >
          <img class="img" :src="zxImgUrl" />
          <div class="text">项目咨询</div>
        </div>
      </div>
      <!-- <div
        class="assistant flex flex-direction align-center justify-around"
        @click="didClick_xzs('wap')"
      >
        <img :src="assistantImgUrl" />
        <span>参会小助手</span>
      </div> -->
    </div>
    <popup v-if="popupShow" @closePopup="closePopup"></popup>
    <!-- 互动iframe -->
    <div class="know-popup interactionIframePopup" v-if="interactionIframe">
      <div class="ai-know-title flex align-center justify-end">
        <div
          class="ai-title-close flex align-center justify-center"
          @click="interactionIframe = false"
        >
          <img :src="popCloseImg" class="know-icon-close" />
        </div>
      </div>
      <iframe
        style="width: 375px; height: 667px; display: block"
        frameborder="0"
        allowfullscreen="allowfullscreen"
        scrolling="yes"
        allow="camera *;microphone *;"
        border="0"
        :src="interactionUrl"
      >
        您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
      </iframe>
    </div>
  </div>
</template>

<script>
import Popup from "./common/Popup";
import Recommend from "./Recommend";
import AcceptDialog from "./recommend/AcceptDialog";
import _ from "lodash";
import { $config } from "../conf";
import { mapState } from "vuex";
import Cookie from "js-cookie";

const { syUrl } = $config;
export default {
  name: "Suspension",
  computed: {
    interactionUrl() {
      // return `http://localhost/?sess=${this.tokenInfo.smarketToken}`;
      return `${$config.interactionUrl}/?sess=${this.tokenInfo.smarketToken}`;
    },
    ...mapState({
      userInfo: (state) => state.userInfo.info,
      tokenInfo: (state) => state.userInfo.token,
      isLogin: (state) => !!state.userInfo.token,
      AttendanceStatus: (state) => state.userInfo.AttendanceStatus,
    }),
  },
  data() {
    return {
      assistantImgUrl: require("../assets/images/suspension/gif-know-avator.gif"),
      openImgUrl: require("../assets/images/suspension/open.png"),
      openbgImgUrl: require("../assets/images/suspension/openbg.png"),
      longbgImgUrl: require("../assets/images/suspension/longbg.png"),
      topArror: require("../assets/images/suspension/toparrow.png"),
      closeImgUrl: require("../assets/images/suspension/close.png"),
      hbImgUrl: require("../assets/images/suspension/hb.png"),
      syImgUrl: require("../assets/images/suspension/sy.png"),
      stImgUrl: require("../assets/images/suspension/st.png"),
      kpImgUrl: require("../assets/images/suspension/kp.png"),
      zxImgUrl: require("../assets/images/suspension/zx.png"),
      xcxImgUrl: require("../assets/images/suspension/xcx.png"),
      xcxbgImgUrl: require("../assets/images/suspension/xcxbg.png"),
      allscreenImg: require("../assets/images/suspension/icon-allscreen.png"),
      popCloseImg: require("../assets/images/suspension/icon-record-close.png"),
      isOpen: false,
      sy: syUrl,
      scrollTop: 100,
      hb: "https://partner.huawei.com/ecpri/#/?lang=zh_CN",
      st: "https://www.hiascend.com/zh/",
      kp: "https://www.hikunpeng.com/zh/",
      zx: "https://e.huawei.com/cn/get-price-info?source_website=MDFDSE5IUTE5NTE0NUw=&ic_medium=hwdc&ic_source=minisite_01CHNHQ215506M&source=stdh_side  和https://support.huawei.com/livechat/chatClient/chatbox.jsp?companyID=8981&configID=59&live800_ud_sq=sqfw&syslanguage=0&enterurl=presale&ic_medium=hwdc&ic_source=minisite_01CHNHQ215506M&source=stdh_side",
      uniknowShow: false, //参会小助手显隐
      qrCodeShow: false, //二维码显隐
      uniknowUlr: "https://app.huawei.com/events/ecomknow/", //参会小助手 iframe url
      popupShow: false, //弹窗是否显示
      recommendshowPc: false, //推荐弹窗是否显示
      recommendshow: false, //推荐弹窗是否显示
      showAcceptPc: false, //推荐弹窗是否显示
      showAccept: false, //推荐弹窗是否显示
      isOut: true, //鼠标移除
      interactionIframe: false,
      status: "",
      knowPopupWidth: "375px",
      acceptRecommend: 0, //用户接受推荐
    };
  },
  components: {
    Popup,
    Recommend,
    AcceptDialog,
  },
  mounted() {
    // if (this.$store.state.isMobile) {
    //   document.addEventListener("click", (event) => {
    //     console.log(event.target);
    //     console.log(document.getElementById("recommendBtnWap").contains(event.target));
    //     if (
    //       document.getElementById("recommendBtnWap") &&
    //       !document.getElementById("recommendBtnWap").contains(event.target)
    //     ) {
    //       this.showAccept = false;
    //       this.recommendshow = false;
    //     }
    //   });
    // }
    // const devicePixelRatio = getWindowRatio();
    // this.knowPopupWidth =
    //   "375px";
    const { offsetHeight, offsetWidth } = document.body;
    const screenRatio = offsetHeight / offsetWidth;
    //宽高比 符合 折叠屏 方块屏时，触发小助手块跟随滑动
    if (screenRatio > 84 / 90 && screenRatio < 10 / 9) {
      // 监听滚动事件
      window.addEventListener(
        "scroll",
        () => {
          let scrollTop =
            document.documentElement.scrollTop ||
            window.pageYOffset ||
            document.body.scrollTop;
          if (
            this.$store.state.isAndroid &&
            document.getElementsByClassName("home-container")[0]
          ) {
            scrollTop = this.$store.state.isAndroid
              ? document.getElementsByClassName("home-container")[0].scrollTop
              : 0;
          }
          if (scrollTop >= 310) {
            this.scrollTop = 310;
          } else {
            this.scrollTop = scrollTop;
          }
        },
        true
      );
    }

    this.status = this.$store.state.userInfo.AttendanceStatus || 3;
    this.$bus.$on("updateStatus", (res) => {
      this.status = res;
    });

    window.addEventListener("message", this.receiveMessage);
    //获取是否允许推荐
    if (this.isLogin) {
      this.$api
        .GetRecommend()
        .then((res) => {
          if (res.result == 0) {
            this.acceptRecommend = res.content;
          }
        })
        .catch((err) => {
          this.acceptRecommend = 0;
        });
    }
  },
  destroyed() {
    this.$bus.$off("updateStatus");
    window.removeEventListener("message", this.receiveMessage, false);
  },
  methods: {
    enter(e) {
      let isOver =
        document.getElementById("recommendBtn").contains(e.target) ||
        this.$refs.recommendContainer.$el.contains(e.target) ||
        this.$refs.acceptContainerPc.$el.contains(e.target);
      if (isOver) {
        this.showAcceptDialog();
      } else {
        this.hideAcceptDialog(e);
      }
    },
    leave(e) {
      this.hideAcceptDialog(e);
      // let isOver =
      //   document.getElementById("recommendBtn").contains(e.target) ||
      //   this.$refs.recommendContainer.$el.contains(e.target) ||
      //   this.$refs.acceptContainer.$el.contains(e.target);
      // if (isOver) {
      //   this.showAcceptDialog();
      // } else {
      //   this.hideAcceptDialog();
      // }
    },
    setAccept(e) {
      Cookie.set("accept_recommend", e);
      this.acceptRecommend = e;
      this.showAccept = false;
      this.showAcceptPc = false;
      if (e) {
        //TODO 这里如果登录之后 需要提交到后台
        if (this.isLogin) {
          //完成任务
          if (e == 1) {
            this.$store.dispatch("interaction/onCompleteTask", {
              desc: "一键懂您",
              objectId: "",
            });
          }
        }
        //向 智能推荐 的 angen 发送消息，重新获取列表
        this.$bus.$emit("reGetList", e);
        this.recommendshow = true;
        this.recommendshowPc = true;
      } else {
        this.recommendshowPc = false;
        this.recommendshow = false;
      }
      if (this.isLogin) {
        this.$api.Recommend({
          type: e,
        });
      }
    },
    hideAcceptDialog(e) {
      if (
        this.$refs.recommendContainerPc.$el.contains(e.toElement) ||
        this.$refs.acceptContainerPc.$el.contains(e.toElement) ||
        e.target.id === "recommendBtn"
      ) {
        this.showAcceptPc = false;
        this.recommendshowPc = false;
        this.$refs.acceptContainerPc.$data.checked = false;
        //this.$refs.acceptContainer.$data.checked = false;
      }
      _.debounce(() => {
        const isIn = document
          .getElementById("recommendBtn")
          .contains(e.toElement);
        if (!isIn) {
          this.$refs.acceptContainerPc.$data.checked = false;
          //this.$refs.acceptContainer.$data.checked = false;
        }
        // if (
        //   !this.$refs.recommendContainer.$el.contains(e.target) &&
        //   !this.$refs.acceptContainer.$el.contains(e.target)
        // ) {
        //   this.showAccept = false;
        //   this.recommendshow = false;
        // }
      });
    },
    showAcceptDialogMobile(e) {
      //埋码
      window._hw("send", "action", "index_AI_recommend_click ");
      if (this.recommendshow) {
        this.showAccept = false;
        this.recommendshow = false;
        return;
      }
      const accept = Cookie.get("accept_recommend");
      if (typeof accept === "undefined") {
        this.showAccept = true;
      } else {
        if (accept == 0) {
          // if (
          //   !this.$refs.recommendContainer.$el.contains(e.target) &&
          //   !this.$refs.acceptContainer.$el.contains(e.target)
          // ) {
          //   if (!this.showAccept) {
          //     this.$refs.acceptContainer.$data.checked = false;
          //   }
          //   this.showAccept = true;
          // }
        } else {
          // if (
          //   !this.$refs.recommendContainer.$el.contains(e.target) &&
          //   !this.$refs.acceptContainer.$el.contains(e.target)
          // ) {
          //   if (!this.showAccept) {
          //     this.$refs.acceptContainer.$data.checked = false;
          //   }
          //   this.recommendshow = !this.recommendshow;
          // }
        }
      }
    },
    showAcceptDialog(e) {
      let accept = 0;
      if (this.isLogin) {
        accept = this.acceptRecommend;
      } else {
        accept = Cookie.get("accept_recommend");
      }
      if (typeof accept === "undefined") {
        this.showAccept = true;
        this.showAcceptPc = true;
      } else {
        if (accept == 0) {
          if (
            !this.$refs.recommendContainerPc.$el.contains(e.target) &&
            !this.$refs.acceptContainerPc.$el.contains(e.target)
          ) {
            // if (!this.showAccept) {
            //   this.$refs.acceptContainer.$data.checked = false;
            // }
            this.showAcceptPc = true;
          }
        } else {
          this.recommendshowPc = true;
        }
      }
    },
    link(url, type) {
      let event = "";
      switch (type) {
        case "hb":
          event = "index_become_partner_click";
          break;
        case "sy":
          event = "index_go_cloud_click";
          break;
        case "st":
          event = "index_hiascend_click";
          break;
        case "kp":
          event = "index_kunpeng_click";
          break;
        case "zx":
          event = "pricing_form_enter";
          break;
      }
      window._hw("send", "action", event);
      //咨询不用跳外链
      if (url === "") return;
      window.open(url); // 新窗口打开外链接
    },
    //点击打开参会小助手
    didClick_xzs(platform) {
      window._hw("send", "action", "index_assistant_click");
      //完成任务
      this.$store
        .dispatch("interaction/onCompleteTask", {
          desc: "私人客服",
          objectId: "",
        })
        .finally(() => {
          if (platform) {
            this.popup_allscreen();
          }
        });
    },
    //参会小助手 展开全屏
    popup_allscreen() {
      window.open(this.uniknowUlr); // 新窗口打开外链接
    },
    //点击小程序
    didClick_xcx() {
      if (!this.$store.state.isMobile) {
        this.qrCodeShow = !this.qrCodeShow;
      }
      window._hw("send", "action", "index_miniapp_code_click");
    },
    gotoWechat() {
      //TODO 需要加手机号
      window.location.href = `${$config.homePage}link.html?type=1&uid=`;
    },
    closePopup() {
      this.popupShow = false;
    },
    changeOpen() {
      this.isOpen = !this.isOpen;
    },
    //点击点我 展开
    didClick_open() {
      this.changeOpen();
      //埋码 开发者大会首页-点击点我展开
      window._hw("send", "action", "index_sidelink_open_click");
    },
    //点击互动判断是否报名
    judgeSign() {
      if (this.status == 3) {
        const { signOnlineUrl } = $config;
        let channel = Cookie.get("channel");
        let url = `${signOnlineUrl}`;
        if (channel) {
          url += `?channel=${channel || ""}&returnUrl=${encodeURIComponent(
            location.href
          )}`;
        } else {
          url += `?returnUrl=${encodeURIComponent(location.href)}`;
        }
        window.location.href = url;
        return false;
      } else {
        return true;
      }
    },
    //打开互动
    openInteraction() {
      let isSign = this.judgeSign();
      isSign && (this.interactionIframe = true);
    },
    //打开互动wap
    openInteractionWap() {
      let isSign = this.judgeSign();
      isSign && window.open(this.interactionUrl, "_blank");
    },
    receiveMessage(e) {
      const { cmd = "", url = "" } = e.data;
      if (cmd == "401") {
        location.reload();
      }
      if (cmd == "点亮星辰") {
        if (this.$route.name == "agenda") {
          this.interactionIframe = false;
        }
        this.$router.push({
          path: "/agenda",
          query: this.$route.query,
        });
      } else if (cmd == "直播传送门") {
        if (this.$route.name == "agenda") {
          this.interactionIframe = false;
        }
        this.$router.push({
          path: "/agenda",
          query: this.$route.query,
        });
      } else if (cmd == "畅游知识城") {
        if (this.$route.name == "agenda") {
          this.interactionIframe = false;
        }
        this.$router.push({
          path: "/agenda",
          query: this.$route.query,
        });
      } else if (cmd == "精彩瞬间") {
        if (this.$route.name == "videos") {
          this.interactionIframe = false;
        }
        this.$router.push({
          path: "/video-list",
          query: this.$route.query,
        });
      } else if (cmd == "洞察之眼") {
        if (this.$route.name == "news") {
          this.interactionIframe = false;
        }
        this.$router.push({
          path: "/news-list",
          query: this.$route.query,
        });
      } else if (cmd == "一键懂您") {
        if (this.$route.name == "home") {
          this.interactionIframe = false;
        }
        this.$router.push({
          path: "/",
          query: this.$route.query,
        });
      } else if (cmd == "私人客服") {
        if (this.$route.name == "home") {
          this.interactionIframe = false;
        }
        this.$router.push({
          path: "/",
          query: this.$route.query,
        });
      } else if (cmd == "追寻回声") {
        if (this.$route.name == "agenda") {
          this.interactionIframe = false;
        }
        this.$router.push({
          path: "/agenda",
          query: this.$route.query,
        });
      } else if (cmd == "自由之声") {
        //完成任务
        this.$store
          .dispatch("interaction/onCompleteTask", {
            desc: "自由之声",
            objectId: "",
          })
          .then((res) => {
            // window.open(url, "_blank");
            window.location.href = url;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#suspension {
  display: none;
}

#suspension-wap {
  display: none;
}

.container {
  background: red;
}

@media screen and (max-width: 992px) {
  #suspension-wap {
    pointer-events: none;
    display: flex;
    z-index: $z-index-suspension;
    position: fixed;
    right: 0;
    bottom: 153px;
    width: 123px;

    .assistant {
      width: 123px;
      pointer-events: auto;
      margin-top: 25px;

      img {
        width: 85px;
      }

      span {
        height: 33px;
        font-size: 16px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #333333;
        line-height: 33px;
      }
    }

    .open {
      position: relative;
      width: 123px;
      height: 125px;
      margin-top: 25px;
      background: rgba(255, 255, 255, 0.5);
      pointer-events: auto;

      img {
        width: 45px;
        height: 45px;
      }

      .text {
        padding-top: 8px;
        font-size: 20px;
        font-family: Microsoft YaHei-Light;

        color: #333333;
        margin-top: 6px;
      }
    }

    .more {
      width: 124px;
      height: 124px;
      margin-top: 21px;
      background: rgba(255, 255, 255, 0.5);
      pointer-events: auto;

      .more_box {
        width: 100%;
        height: 100%;

        .img {
          width: 45.5px;
          height: 45.5px;
        }

        .text {
          //padding-top: 8px;
          //margin-top: 4px;
          font-size: 20px;
          font-family: Microsoft YaHei-Light;

          color: #333333;
          //line-height: 33px;
        }
      }

      .topArror {
        width: 12px;
        height: 6px;
      }
    }

    .minipro {
      width: 123px;
      height: 125px;
      margin-top: 25px;
      background: rgba(255, 255, 255, 0.5);
      position: relative;
      display: flex;
      flex-direction: column;
      pointer-events: auto;

      img {
        width: 45px;
        height: 45px;
      }

      .text {
        padding-top: 8px;
        font-size: 20px;
        font-family: Microsoft YaHei-Light;

        color: #333333;
        margin-top: 6px;
      }

      .qrCode {
        width: 50vw;
        height: 60vw;
        border: 1px solid #000000;
        border-radius: 10px;
        position: fixed;
        left: 25vw;
        top: calc(50vh - 25vw);
        background-color: #ffffff;

        .qrImg {
          width: 90%;
          height: 80%;
          background-color: #b4251e;
        }

        .text {
          padding-top: 8px;
          font-size: 16px;
          font-family: Microsoft YaHei-Light;

          color: #333333;
        }

        .closeImg {
          width: 30px;
          height: 30px;
          padding: 5px;
          border-radius: 50%;
          background-color: rgba(0, 0, 0, 0.3);
          position: absolute;
          right: -30px;
          top: -30px;
        }
      }
    }
  }
}

@media screen and (min-width: 992px) {
  #suspension {
    display: flex;
    z-index: $z-index-suspension;
    position: fixed;
    right: 14px;
    top: 20px;
    width: 123px;
    height: 100vh;

    .assistant {
      margin-top: 15px;
      width: 122px;
      height: 148px;
      pointer-events: auto;

      img {
        margin: 0 auto;
        width: 70px;
      }

      span {
        height: 33px;
        font-size: 16px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #333333;
        line-height: 33px;
      }
    }

    .open {
      position: relative;
      margin: 0 auto;
      margin-top: 15px;
      //width: 91px;
      padding: 10px 10px 6px 10px;
      min-width: 91px;
      //height: 102px;
      pointer-events: auto;
      background: rgba(255, 255, 255, 0.3);
      border: 1px solid rgba(243, 156, 98, 0.4);

      &.interaction {
        height: 120px;
        img {
          height: auto;
        }
      }

      img {
        width: 37px;
        height: 37px;
      }

      .text {
        padding-top: 8px;
        font-size: 16px;
        font-family: Microsoft YaHei-Light;

        color: #333333;
      }
    }

    .more {
      margin: 15px auto 0;
      width: 91.5px;
      padding-bottom: 10px;
      pointer-events: auto;
      background: rgba(255, 255, 255, 0.3);
      border: 1px solid rgba(243, 156, 98, 0.4);

      .more_box {
        width: 91px;
        height: 91px;

        //&:first-child {
        //  border-bottom: 1px solid #ffffff;
        //}

        .img {
          width: 37px;
          height: 37px;
        }
        .img2 {
          width: 44px;
          height: 33px;
        }

        .text {
          padding-top: 8px;
          margin-top: 4px;
          font-size: 16px;
          font-family: Microsoft YaHei-Light;

          color: #333333;
        }
      }

      .topArror {
        width: 12px;
        height: 6px;
      }
    }

    .minipro {
      margin: 0 auto;
      padding: 10px 10px 6px 10px;
      min-width: 91px;
      margin-top: 15px;
      position: relative;
      pointer-events: auto;
      background: rgba(255, 255, 255, 0.3);
      border: 1px solid rgba(243, 156, 98, 0.4);

      img {
        width: 37px;
        height: 37px;
      }

      .text {
        padding-top: 8px;
        font-size: 16px;
        font-family: Microsoft YaHei-Light;

        color: #333333;
      }

      .qrCode {
        display: block;
        width: 200px;
        height: 240px;
        position: absolute;
        left: -220px;
        top: 0;
        background-color: #ffffff;
        margin: 0 auto;
        text-align: center;

        .qrImg {
          width: 180px;
          height: 180px;
          background-color: #b4251e;
        }

        .text {
          padding-top: 8px;
          font-size: 16px;
          margin-top: 20px;
          font-family: Microsoft YaHei-Light;

          color: #333333;
        }
      }
    }

    .know-popup {
      display: block;
      width: 455px;
      background: #f5f9fc;
      box-shadow: 0 0 10px 0 rgb(26 44 58 / 35%);
      border-radius: 6px;
      height: 700px;
      position: fixed;
      bottom: 10px;
      right: 20px;
      overflow: hidden;

      .ai-know-title {
        padding: 0 20px;
        height: 45px;
        line-height: 45px;
        background: #ffffff;
        box-shadow: 0 1px 6px 0 rgb(0 0 0 / 5%);
        position: relative;

        .ai-title-allscreen {
          width: 30px;
          height: 30px;
          cursor: pointer;
          text-align: center;

          .know-icon-allscreen {
            width: 16px;
            height: 16px;
          }

          .ai-title-allscreen_hover {
            display: none;
          }
        }

        .ai-title-allscreen:hover {
          .ai-title-allscreen_hover {
            padding: 4px 6px;
            display: block;
            background: rgba(51, 51, 51, 0.7);
            border-radius: 2px;
            color: #fff;
            position: absolute;
            top: 90%;
            right: 1%;
            transform: translateX(-50%);
            white-space: nowrap;
            font-size: 12px;
            line-height: 22px;
          }
        }

        .ai-title-close {
          width: 30px;
          height: 30px;
          cursor: pointer;

          .know-icon-close {
            width: 12px;
            height: 12px;
          }
        }
      }

      iframe {
        width: 100%;
        height: calc(100% - 45px);
        border: 0 solid;
      }
    }
  }

  .interactionIframePopup.know-popup {
    display: block;
    background: #f5f9fc;
    box-shadow: 0 0 10px 0 rgb(26 44 58 / 35%);
    border-radius: 6px;
    position: fixed;
    bottom: 10px;
    right: 20px;
    overflow: hidden;
    z-index: 200;

    .ai-know-title {
      padding: 0 20px;
      height: 45px;
      line-height: 45px;
      background: #ffffff;
      box-shadow: 0 1px 6px 0 rgb(0 0 0 / 5%);
      position: relative;

      .ai-title-allscreen {
        width: 30px;
        height: 30px;
        cursor: pointer;
        text-align: center;

        .know-icon-allscreen {
          width: 16px;
          height: 16px;
        }

        .ai-title-allscreen_hover {
          display: none;
        }
      }

      .ai-title-allscreen:hover {
        .ai-title-allscreen_hover {
          padding: 4px 6px;
          display: block;
          background: rgba(51, 51, 51, 0.7);
          border-radius: 2px;
          color: #fff;
          position: absolute;
          top: 90%;
          right: 1%;
          transform: translateX(-50%);
          white-space: nowrap;
          font-size: 12px;
          line-height: 22px;
        }
      }

      .ai-title-close {
        width: 30px;
        height: 30px;
        cursor: pointer;

        .know-icon-close {
          width: 12px;
          height: 12px;
        }
      }
    }

    iframe {
      // width: 375px;
      // height: 667px;
      border: 0;
      display: block;
    }
  }
}

/* 屏幕分辨率放大为 150 */
@media (-webkit-min-device-pixel-ratio: 1.25) {
  .interactionIframePopup.know-popup {
    transform: scale(0.8, 0.8); /* 缩放数值需要根据效果调试 */
    transform-origin: right bottom;
  }
}

@media screen and (min-aspect-ratio: 84/90) and (max-aspect-ratio: 100/90) {
  $place-width: 90px;
  #suspension-wap {
    display: block;
    position: fixed;
    bottom: 80px;
    width: $place-width;
    pointer-events: none;
    z-index: $z-index-suspension;
    align-items: flex-end;

    .assistant {
      width: $place-width;
      pointer-events: auto;

      img {
        width: 68px;
      }

      span {
        height: 33px;
        font-size: 14px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #333333;
        line-height: 24px;
      }
    }

    .open {
      width: $place-width;
      height: $place-width + 20px;

      img {
        width: $place-width * 0.36;
        height: $place-width * 0.36;
      }

      .text {
        padding-top: 8px;
        font-size: 16px;
        font-family: Microsoft YaHei-Light;

        color: #333333;
        margin-top: 4px;
      }
    }

    .more {
      width: $place-width;
      padding-bottom: 10px;
      margin-top: 21px;
      background: rgba(255, 255, 255, 0.5);
      pointer-events: auto;

      .more_box {
        width: $place-width;
        height: $place-width + 20px;

        .img {
          width: $place-width * 0.36;
          height: $place-width * 0.36;
        }

        .text {
          padding-top: 8px;
          margin-top: 4px;
          font-size: 14px;
          font-family: Microsoft YaHei-Light;

          color: #333333;
        }
      }

      .topArror {
        width: 12px;
        height: 6px;
      }
    }

    .minipro {
      width: $place-width;
      height: $place-width + 20px;
      margin-top: 25px;
      background: rgba(255, 255, 255, 0.5);
      position: relative;
      display: flex;
      flex-direction: column;
      pointer-events: auto;

      img {
        width: $place-width * 0.36;
        height: $place-width * 0.36;
      }

      .text {
        padding-top: 8px;
        font-size: 16px;
        font-family: Microsoft YaHei-Light;

        color: #333333;
        margin-top: 4px;
      }

      .qrCode {
        width: 50vw;
        height: 60vw;
        border: 1px solid #000000;
        border-radius: 10px;
        position: fixed;
        left: 25vw;
        top: calc(50vh - 25vw);
        background-color: #ffffff;

        .qrImg {
          width: 90%;
          height: 80%;
          background-color: #b4251e;
        }

        .text {
          padding-top: 8px;
          font-size: 14px;
          font-family: Microsoft YaHei-Light;

          color: #333333;
        }

        .closeImg {
          width: 30px;
          height: 30px;
          padding: 5px;
          border-radius: 50%;
          background-color: rgba(0, 0, 0, 0.3);
          position: absolute;
          right: -30px;
          top: -30px;
        }
      }
    }

    .scroll-open {
      position: fixed;
    }
  }
}
</style>
